import { render, staticRenderFns } from "./Home.data-manager-stags-versions.vue?vue&type=template&id=3710f7ed&scoped=true&"
import script from "./Home.data-manager-stags-versions.vue?vue&type=script&lang=js&"
export * from "./Home.data-manager-stags-versions.vue?vue&type=script&lang=js&"
import style0 from "./Home.data-manager-stags-versions.vue?vue&type=style&index=0&id=3710f7ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3710f7ed",
  null
  
)

export default component.exports